module.exports = __webpack_public_path__ + "static/media/wifi-2.2526799c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/wifi-2.jpg
// module id = 627
// module chunks = 6